export const locale = {
    lang: 'en',
    data: {
      'NOMBREIDIOMAS': {
        'es': 'Spanish',
        'en': 'English',
        'pt': 'Portuguese',
        'zh1': 'Traditional Chinese',
        'zh2': 'Simplified Chinese',
        'tr': 'Turkish',
        'vi': 'Vietnamese',
        'ja': 'Japanese',
        'my': 'Malay',
        'ro': 'Romanian',
        'ru': 'Russian',
        'fr': 'French',
        'de': 'German',
        'it': 'Italian',
        'nl':'Dutch',
        'ms': 'Malay',
        'hi': 'Hindi',
        'id': 'Indonesian',
        'ua': 'Ukrainian',
        'ge': 'Georgian',
        'uz': 'Uzbek',
        'az': 'Azeri',
        'kk': 'Kazakh',
        'hr': 'Croatian',
        'ar': 'Arab',
        'mk': 'Macedonian',
        'lv': 'Latvian',
        'pr': 'Portuguese (Portugal)',
        'th': 'Thai',
      },
      'SELECTOR': {
        'es': 'Español',
        'en': 'English',
        'pt': 'Português',
        'zh1': '繁體中文',
        'zh2': '简体中文',
        'tr': 'Türkçe',
        'vi': 'Vietnamese',
        'jp': 'Japanese',
        'my': 'Malay',
        'ro': 'Romanian',
        'ru': 'Russian',
        'nl':'Nederlands',
        'de': 'Deútsche'
        //Nederlands
      }
    }
};
